<div class="priceListLanding">
  <div class="nplLanding priceList-wrapper" style="width: 100%; margin:0;">
    <div class="priceListLandingPage  margin-0">
      <div class="topSection">

        <div class="alignTopSec relative">
          <div class="row">
            <div class="col">
              <div class="order-view-sec breadcrumbOuter padding-0 " id="orderView1">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item active">
                      <a href="javascript:void(0)" routerLink="/pricelistLookup/customer-price-list">CPP Price Lookup</a>
                      <i class="fas fa-angle-right"></i>
                    </li>
                    <li class="breadcrumb-item breadcrumbColor">
                      <span>{{accountName}}</span>
                    </li>
                  </ol>
                </nav>
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-sec">
                <div class="row margin-b10 margin-r0 margin-l0 ">
                  <div class="col-md-12 col-lg-12 p-0 padding-l0">
                    <div class="search-box-outer">
                      <div class="borderLeft padding-l4 padding-r0 searchRtSection">
                        <div class="material-select reports-search-filter d-flex justify-content-between">
                          <ng-container *ngTemplateOutlet="tmplInputTime; context: { value:productFilters}">
                          </ng-container>
                          <div class="mobileAlignment">
                            <button mat-raised-button class="btns" [disabled]="disableFilterBtn" (click)="retainFilter(null, ' ');getCPPProductData();" color="primary">Search</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="chips-sec">
                          <div class="row selected-chip align-items-center mt-2 pb-0">
                            <div class="col-10 padding-l0 padding-r0">
                              <div>
                                <mat-chip-set>
                                  <mat-chip selected *ngFor="let filterValue of filterValueList" [removable]="true">
                                    {{filterValue}}
                                    <a href="Javascript:void(0);" (click)="clearAllFilter()">
                                      <i class="fas fa-times text-right"></i>
                                    </a>
                                  </mat-chip>
                                </mat-chip-set>
                              </div>
               
                            </div>
                            <div class="col-2 p-0 text-right padding-r30" *ngIf="filterValueList.length > 0">
                              <a href="Javascript:void(0);" class="clearAll mt-0 white-space-nowrap" (click)="clearAllFilter()">Clear All</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomSection pt-0">
        <div class="py-1">
          <h5  class="text-center price-disclaimer">Prices subject to change without notice. All Products (except inoculants) priced date of shipment & prices refresh daily.</h5>
        </div>
        
        <div class="row">
        
          <div class="col-md-12 productTableOuter">
            <div class="tableWrapper">
              <div class="fulfill-top-sec">
                <div class="text-right mobile-pad-0">
                  <div class="display-ib wAuto mx-2 mt-4 mb-3  price-list-paginator">
                    <mat-paginator #priceListPaginator [pageSize]="25" [pageSizeOptions]="[5, 10, 25]"></mat-paginator>
                  </div>
                </div>
              </div>
              <div class="tableContainer priceListTable" id="cppOrderView">
                <table mat-table #placedCPPOrdersTable [dataSource]="cppProductListDataSource" multiTemplateDataRows class="matTables">
                  <ng-container matColumnDef="{{column}}" *ngFor="let column of priceListCPPColumns">
                    <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product </th>
              </div>
              <div *ngIf="column=='price'"><th mat-header-cell *matHeaderCellDef class="package text-center">Your Price</th></div>
  
              <td mat-cell *matCellDef="let element">
                <div *ngIf="column=='product'">
                  <div class="order-info">
                    <div class="grower-name d-flex align-items-center" *ngIf="element.isGroup && headerCompany === masterConstants.US_COMPANYCODE">
                      {{element.isGroup ? element.hvDesc:element.supplier}}
                      <span class="restrictedStyle" *ngIf="element.isGroup === true && (element.rup === 'Y')">RESTRICTED</span>
                    </div>
                    <p class="itemName">
                      <span>{{element.prodDesc}}</span>
                    </p>
                  </div>
                </div>
  
  
                <div *ngIf="column=='price'" class="showHideDetails text-center">
                  <span class="prod-total-price padding-b0"
                        [ngClass]="{'pricing-uom':element.isGroup && headerCompany === masterConstants.US_COMPANYCODE}">
                    <ng-container *ngIf="headerCompany === masterConstants.US_COMPANYCODE;else june">
                      {{element.isGroup ? 'PER '+element.pricingUom : element.basePrice | currency :element.cur:'symbol':'1.4-4'}}
                    </ng-container>
                    <ng-template #june>
                      {{
                        (element.isGroup ? 'PER '+element.pricingUom : element.basePrice | currency :element.cur:'symbol': masterConstants.NUMBER_FORMAT)
                      }}
                    </ng-template>
                  </span>
                </div>
              </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="priceListCPPColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let element; columns: priceListCPPColumns"
                  [ngClass]="{'groupName':element.isGroup,
                      'example-element-row':(element.isGroup=== false),
                      'hide-row': (element.hvDesc=== null)}"
                  id="tr_exp_{{element.rowNo}}"></tr>
              </table>
  
              <div *ngIf="cppProductListDataSource == undefined || cppProductListDataSource?.data.length == 0" class="noDataMsg">
                <p>No Record Found.</p>
              </div>
              </div>
              
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #tmplInputTime let-value="value">
  <div class="wide100">
    <div class="search-box-outer">
      <div class="search-box wide100">
        <span class="search-icon">
          <i class="fas fa-search"></i>
        </span>
        <div class="select-container">
          <ng-container>
            <app-typeahead style="top: 7px; left: 42px; position: absolute;width: 100%;" (modelChange)="updatedVal($event); retainFilter(null, ' ');getCPPProductData();" (textLengthDetect)="validateProduct($event)" [listData]="productNameSearchList" [searchPlaceHolder]="'Search Product'"></app-typeahead>
            <!--<span aria-label="Clear" class="input-group-text clearFilter" (click)=clearInput()>
              <i class="fa fa-times"></i>
            </span>-->
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>
